import { getSeasonalOverrideThemeId } from "./seasonalRules";

const LEGACY_THEME_ID_MAP = {
  moltenCopper: "molten",
  executive_commercial: "executive-commercial",
  commercialBase: "executive-commercial",
  commercial: "executive-commercial",
};

function normalizeThemeId(themeId) {
  if (!themeId) return themeId;
  return LEGACY_THEME_ID_MAP[themeId] ?? themeId;
}

export function resolveActiveThemeId(input) {
  const now = input.now ?? new Date();
  const seasonal = getSeasonalOverrideThemeId(now);

  // Precedence: seasonalOverride ?? userSelectedTheme ?? orgTheme ?? default
  const resolved = seasonal ?? input.userThemeId ?? input.orgThemeId ?? "executive-commercial";
  return normalizeThemeId(resolved);
}
